export default __webpack_public_path__ + "static/media/checkmark.e7bc4139.svg";